import { useEffect, useRef } from 'react';

const SITE_KEY   = process.env.REACT_APP_TURNSTILE_SITE_KEY;
const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js';

// Whether Turnstile is enabled in this build (site key present).
export const captchaEnabled = !!SITE_KEY;

/**
 * Cloudflare Turnstile widget. Calls onVerify(token) when solved, and
 * onVerify('') on error/expiry. Renders nothing when no site key is set.
 */
export default function Turnstile({ onVerify }) {
  const boxRef    = useRef(null);
  const widgetRef = useRef(null);
  const cbRef     = useRef(onVerify);
  cbRef.current   = onVerify;

  useEffect(() => {
    if (!SITE_KEY) return;
    let cancelled = false;

    const render = () => {
      if (cancelled || !window.turnstile || !boxRef.current || widgetRef.current !== null) return;
      widgetRef.current = window.turnstile.render(boxRef.current, {
        sitekey: SITE_KEY,
        callback:            (t) => cbRef.current(t),
        'error-callback':    ()  => cbRef.current(''),
        'expired-callback':  ()  => cbRef.current(''),
      });
    };

    if (window.turnstile) {
      render();
    } else {
      if (!document.querySelector(`script[src="${SCRIPT_URL}"]`)) {
        const s = document.createElement('script');
        s.src = SCRIPT_URL; s.async = true; s.defer = true;
        document.head.appendChild(s);
      }
      const poll = setInterval(() => {
        if (window.turnstile) { clearInterval(poll); render(); }
      }, 200);
      return () => { cancelled = true; clearInterval(poll); };
    }

    return () => {
      cancelled = true;
      if (widgetRef.current !== null && window.turnstile) {
        try { window.turnstile.remove(widgetRef.current); } catch {}
        widgetRef.current = null;
      }
    };
  }, []);

  if (!SITE_KEY) return null;
  return <div ref={boxRef} className="my-3 flex justify-center" />;
}
